/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconZzz = createReactComponent("zzz", "IconZzz", [
  ["path", { d: "M4 12h6l-6 8h6", key: "svg-0" }],
  ["path", { d: "M14 4h6l-6 8h6", key: "svg-1" }]
]);

export { IconZzz as default };
//# sourceMappingURL=IconZzz.js.map
